import { render } from "./Test.vue?vue&type=template&id=0383bba8&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=0383bba8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0383bba8"

export default script